import Nullstack from 'nullstack';
export default function IconMathSymbols({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-math-symbols",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "16.5",
    y1: "4.5",
    x2: "19.5",
    y2: "7.5"
  }), "   ", Nullstack.element("line", {
    x1: "19.5",
    y1: "4.5",
    x2: "16.5",
    y2: "7.5"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "4",
    x2: "6",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "6",
    x2: "8",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "16",
    x2: "18.01",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "20",
    x2: "18.01",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "18",
    x2: "8",
    y2: "18"
  }), " ");
}